import { Component, Input, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup as NgFormGroup,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import moment from 'moment';

@Component({
    selector: 'ticket-date-picker',
    templateUrl: 'component.html',
    styleUrls: ['component.scss'],
    standalone: false
})
export class TicketDatePicker implements OnInit {
  @Input() ParentFormGroup: NgFormGroup;
  @Input() startDate: string;
  @Input() endDate: string;
  @Input() stagedRelease: boolean;
  @Input() releaseDate: string;

  public startDateFixed: boolean;
  public endDateFixed: boolean;
  public rules: boolean;
  public rulesMessage: string;

  public calendar: boolean;
  public FormGroup: NgFormGroup;

  public eventTimes = [
    {
      name: 'Morning',
      time: '0900',
    },
    {
      name: 'Afternoon',
      time: '1400',
    },
    {
      name: 'Evening',
      time: '1900',
    },
  ];

  public ngOnInit() {
    const builder = new FormBuilder();

    this.setRulesMessage();

    this.FormGroup = builder.group(
      {
        startDate: null,
        startTime: [null],
        endDate: [null],
        calendar: [null],
        showDangerousSettings: [false],
        stagedRelease: [null],
        stagedReleaseDate: [null],
      },
      {
        validator: this.validateDates.bind(this),
      }
    );
    this.resetForm();
  }

  public resetForm() {
    this.FormGroup.get('startDate').patchValue(
      this.getStartOfDay(this.startDate)
    );
    this.FormGroup.get('endDate').patchValue(this.getStartOfDay(this.endDate));

    if (this.ParentFormGroup.get('startTime').value) {
      const eventTimeValue = this.eventTimes
        .filter(
          (eventTime) =>
            eventTime.name === this.ParentFormGroup.get('startTime').value.name
        )
        .pop();

      this.FormGroup.get('startTime').patchValue(eventTimeValue);
    }

    this.startDateFixed = !!this.startDate;
    this.endDateFixed = !!this.endDate;
    this.rules = !this.ParentFormGroup.get('anarchy').value;
    this.calendar =
      this.ParentFormGroup.get('calendar').value !== null
        ? this.ParentFormGroup.get('calendar').value
        : true;
    this.FormGroup.get('stagedRelease').patchValue(this.stagedRelease);
    this.FormGroup.get('stagedReleaseDate').patchValue(
      this.getStartOfDay(this.releaseDate)
    );

    this.FormGroup.markAsPristine();
  }

  protected setErrors(ParentFormGroup: NgFormGroup, FormGroup: NgFormGroup) {
    ParentFormGroup.get('startDate').setErrors(
      FormGroup.get('startDate').errors
    );
    ParentFormGroup.get('endDate').setErrors(FormGroup.get('endDate').errors);
  }

  public setRulesMessage() {
    const status = this.rules ? 'on' : 'off';
    this.rulesMessage = `Purchasing rules are ${status}`;
  }

  protected validateDates(FormGroup: NgFormGroup) {
    const dates = FormGroup.getRawValue();

    this.validateEndDate(dates, FormGroup);

    this.setErrors(this.ParentFormGroup, FormGroup);
  }

  public setAnarchy(anarchy: boolean) {
    this.setRulesMessage();
    this.ParentFormGroup.controls['anarchy'].patchValue(anarchy);
  }

  public setEventCalendar(calendar: boolean) {
    this.ParentFormGroup.controls['calendar'].patchValue(calendar);
  }
  public setStagedRelease(stagedRelease: boolean) {
    this.stagedRelease = stagedRelease;
    this.ParentFormGroup.controls['stagedRelease'].patchValue(stagedRelease);
  }
  public setEndDateFixed(fixed: boolean) {
    if (fixed) {
      const endDate = this.endDate ? moment(this.endDate).startOf('day') : null;
      const endDateObject = endDate ? endDate.toDate() : null;
      const endDateString = endDate ? endDate.format('DD/MM/YYYY') : null;

      this.FormGroup.controls['endDate'].patchValue(endDateObject);
      this.ParentFormGroup.controls['endDate'].patchValue(endDateString);

      this.endDateFixed = fixed;
    } else {
      this.endDateFixed = fixed;

      this.FormGroup.controls['endDate'].patchValue(null);
      this.ParentFormGroup.controls['endDate'].patchValue(null);
    }
  }

  public onDateChange(fieldName) {
    this.ParentFormGroup.controls[fieldName].patchValue(
      this.getDateString(fieldName)
    );
  }

  public onStartTimeChange(event: any) {
    this.ParentFormGroup.controls['startTime'].patchValue(event.value);
  }

  protected validateEndDate(dates: any, FormGroup: NgFormGroup) {
    let errors: ValidationErrors = [];

    const validMin =
      !dates.endDate ||
      !dates.startDate ||
      moment(dates.endDate).isSameOrAfter(dates.startDate);

    !validMin &&
      errors['push']({
        error: 'endDateMin',
        message: 'End date must be after, or the same as start date',
      });

    errors = errors['length'] ? errors : null;

    FormGroup.controls['endDate'].setErrors(errors);
  }

  protected getStartOfDay(date: string): Date {
    return date ? moment(date, 'DD/MM/YYYY').startOf('day').toDate() : null;
  }

  protected getDateString(index: string): string {
    return moment(this.FormGroup.get(index).value).format('DD/MM/YYYY');
  }
}
